import Vue from 'vue';
import Component from 'vue-class-component';
import {AXIOS} from "@/lib/http-common";
import {DatabaseInfo, Databases} from "@/components/jdbc/Databases";
import PropertyField from "@/components/properties/PropertyField.vue";
import ColumnDto from "@/components/jdbc/ColumnDto";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import {TableMergeOption} from "@/components/properties/settings/jdbc/TableMergeOption";

@Component({
  components: {PropertyField},
  computed: {
    TableMergeOption() {
      return TableMergeOption;
    },
    Databases() {
      return Databases;
    }
  }
})
export default class JdbcSettingView extends Vue {
  public columns: ColumnDto [] = [];
  public isLoadingColumns: boolean = false;
  public isLoadingTargetColumns: boolean = false;
  public isTestingDbConnection: boolean = false;
  public targetColumns: string[] = [];
  public jdbcItemColumnApiUrl: string = "/jdbc-item-column";
  public jdbcApiUrl: string = "/jdbc";
  public targetColumnsValues: string[] = [];
  public databaseHint: string = '';

  public areColumnValuesLoaded(): boolean {
    return this.columns.length > 0 && this.columns.length === this.targetColumnsValues.length;
  }

  public handleColumnValueLoaded(columnValue: any) {
    this.targetColumnsValues.push(columnValue);
  }

  public handleColumnValueChanged(columnValue: any, index: number) {
    this.targetColumnsValues[index] = columnValue;
  }

  public handleDatabaseValueLoaded(databaseValue: Databases) {
    this.handleDatabaseValueChanged(databaseValue);
  }

  public handleDatabaseValueChanged(databaseValue: Databases) {
    this.databaseHint = DatabaseInfo[databaseValue];
  }

  public mounted() {
    this.getColumns();
  }

  public getColumns() {
    this.isLoadingColumns = true;
    AXIOS.get("/jdbc/source-columns")
      .then((message) => {
        this.columns = message.data;
      })
      .finally(() => this.isLoadingColumns = false);
  }

  public loadTargetDBColumns() {
    this.isLoadingTargetColumns = true;
    AXIOS.get("/jdbc/target-columns")
      .then((message) => {
        this.targetColumns = message.data;
      })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => this.isLoadingTargetColumns = false);
  }

  public testConnection() {
    this.isTestingDbConnection = true;
    AXIOS.post("/jdbc/test-db-connection")
      .then((message) => {
        if (message.data === true) {
          UserActionResultSender.showSuccessFeedback("jdbc.testConnectionSuccessful");
        } else {
          UserActionResultSender.showErrorFeedback("jdbc.testConnectionFailed");
        }
      })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => this.isTestingDbConnection = false);
  }

  public validateColumnName(columnName: string): string | boolean {
    if (columnName === undefined || columnName === null) {
      columnName = '';
    }

    if (columnName.length === 0) {
      return true;
    }

    const regex = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
    if (!regex.test(columnName)) {
      return 'Invalid column name. Only alphanumeric characters and underscores are allowed, and it must start with a letter or underscore.';
    }

    if (this.areColumnValuesLoaded() && this.targetColumnsValues.filter(col => col.length > 0).includes(columnName)) {
      const previousColumnName = columnName.substring(0, columnName.length - 1);
      const previousColumnNameIndex = this.targetColumnsValues.findIndex(col => col === previousColumnName);
      if (previousColumnNameIndex !== -1) {
        this.targetColumnsValues[previousColumnNameIndex] = this.targetColumnsValues[previousColumnNameIndex].slice(0, -1);
      }
      return `There is another column with name [${columnName}]`;
    }

    return true;
  }
}
